import { useState, useContext, useReducer, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Layout from "../layouts/Default";
import AuthContext from "../contexts/auth";
import ProfileContext, { ProfileContextProvider } from "../contexts/profile";
import Dialog from "../components/dialogs/Dialog";
import Text from "../components/typography/Text";
import Button from "../components/buttons/Button";
import fetchApi from "../fetchApi";

// Tabs
import AccountTab from "../parts/UserForm/AccountSetting";
import AboutMeTab from "../parts/UserForm/AboutMe";
import AboutStartup from "../parts/UserForm/AboutStartup";
import LocationSocialsTab from "../parts/UserForm/LocationSocials";
import SocialTab from "../parts/UserForm/Social";
import WhatYouDoTab from "../parts/UserForm/WhatYouDo";

const tabComponents = {
  account: AccountTab,
  aboutMe: AboutMeTab,
  aboutStartup: AboutStartup,
  locationSocials: LocationSocialsTab,
  social: SocialTab,
  whatyoudo: WhatYouDoTab,
};

const designerTabs = [
  { label: "About Me", value: "aboutMe" },
  { label: "Location and socials", value: "locationSocials" },
  { label: "Account", value: "account" },
];

const entrepreneurTabs = [
  { label: "About your startup", value: "aboutStartup" },
  { label: "Social", value: "social" },
  { label: "What you do", value: "whatyoudo" },
  { label: "Account", value: "account" },
];

const Settings = ({ location }) => {
  const { user, logout } = useContext(AuthContext);
  const { save, saved, data = {}, setData } = useContext(ProfileContext);
  const [tabs, setTabs] = useState(designerTabs);
  const [tab, setTab] = useState(location.state || tabs[0].value);
  const [showDialog, toggleDialog] = useReducer(s => !s, false);
  const [errors, setError] = useReducer(reduceError, []);
  const history = useHistory();
  const Form = tabComponents[tab];

  useEffect(() => {
    const userTabs =
      user && user.role === "designer" ? designerTabs : entrepreneurTabs;
    setTabs(userTabs);
    setTab(location.state || userTabs[0].value);
  }, [user]);

  const next = async () => {
    if (!errors || errors.length === 0) return save();
  };

  const deleteAccount = async () => {
    try {
      const result = await fetchApi(`/users/delete/${user.id}`, {
        method: "delete",
      });
      console.log({ result });
      if (result.code === 200) logout();
      else
        alert(
          "Can't delete this user currently. Please contact an administrator."
        );
      toggleDialog();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setError();
  }, [tab]);

  if (!user) {
    console.log("No user");
    return null;
  }

  return (
    <>
      <Layout title="Profile">
        <div className="pSettings">
          <div className="pSettings_wrapper">
            <div className="pSettings_menu">
              {tabs.map((item, index) => (
                <Tab
                  key={index}
                  {...item}
                  isActive={tab === item.value}
                  onClick={() => {
                    history.push({ state: item.value });
                    setTab(item.value);
                  }}
                />
              ))}
              <h5 className="pSettings_remove" onClick={toggleDialog}>
                Delete my account
              </h5>
            </div>
            <div className="pSettings_form">
              <Form
                errors={errors}
                setError={setError}
                data={data}
                setData={setData}
                next={next}
                saved={saved}
                btnLabel={saved ? "Saved!" : "Save"}
              />
              {errors && errors.length > 0 && (
                <ul className="pSignUp_error">
                  {errors.map((err, index) => (
                    <li key={index}>{err.message}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </Layout>
      <Dialog show={showDialog} toggle={toggleDialog}>
        <div className="dialog_content">
          <h4>Delete account</h4>
          <Text small>
            Are you sure you want to delete your account permanently ?
          </Text>
          <div className="dialog_actions">
            <Button outlined rounded onClick={toggleDialog}>
              Cancel
            </Button>
            <Button rounded onClick={deleteAccount}>
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

const Tab = ({ isActive, label, onClick }) => (
  <div
    className={`pSettings_tab ${isActive ? "active" : ""}`}
    onClick={onClick}
  >
    {label}
  </div>
);

const reduceError = (state, action) =>
  action ? [...state, { ...action }] : [];

export default props => (
  <ProfileContextProvider>
    <Settings {...props} />
  </ProfileContextProvider>
);
